import React from "react";
import "./ShortListRejectButton.css";

const ShortListRejectButton = ({
  shortList,
  Reject,
  status = "",
  userId = "",
  shortListRef=null,
  rejectRef=null,
}) => {
  // console.log(status);
  return (
    <div className="action-buttons">
      <button
        ref={shortListRef}
        onClick={
          status !== "SHORTLIST" && status !== "REJECTED"
            ? () => shortList(userId)
            : null
        }
        className={
          status === "SHORTLIST" || status === "REJECTED"
            ? "disable-btn"
            : "shortlist-btn"
        }
        disabled={status === "SHORTLIST" || status === "REJECTED"}
      >
        {status === "SHORTLIST" ? "Shortlisted" : "Shortlist"}
      </button>
      <button
        ref={rejectRef}
        onClick={status !== "REJECTED" ? () => Reject(userId) : null}
        className={status === "REJECTED" ? "disable-btn" : "reject-btn"}
        disabled={status === "REJECTED"}
      >
        {status === "REJECTED" ? "Rejected" : "Reject"}
      </button>
    </div>
  );
};

export default ShortListRejectButton;
